// メルマガポップアップ — 左下トリガーで dialog 開閉

class CmNewsletterPopup extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const dialog = this.querySelector('dialog');
    const toggleButton = this.querySelector('[data-newsletter-popup-toggle]');
    const labelOpen = this.dataset.labelOpen || '';
    const labelClose = this.dataset.labelClose || '';

    if (!dialog || !toggleButton) return;

    const setOpenState = (isOpen) => {
      toggleButton.classList.toggle('is-open', isOpen);
      toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggleButton.setAttribute('aria-label', isOpen ? labelClose : labelOpen);
    };

    const open = () => {
      if (dialog.open) return;
      try {
        const panel = dialog.querySelector('.cm-newsletter-popup__panel');
        dialog.showModal();
        // showModal() のデフォルト（先頭入力へのフォーカス）を避ける
        panel?.focus({ preventScroll: true });
        setOpenState(true);
      } catch (_) {
        // 他のdialog表示中など
      }
    };

    const close = () => {
      if (!dialog.open) return;
      dialog.close();
    };

    toggleButton.addEventListener('click', () => {
      if (dialog.open) close();
      else open();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('close', () => {
      setOpenState(false);
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    // 送信結果メッセージがあるときは自動で開く
    if (this.querySelector('.cm-newsletter-popup__message--error, .cm-newsletter-popup__message--success')) {
      requestAnimationFrame(open);
    }
  }
}

if (!customElements.get('cm-newsletter-popup')) {
  customElements.define('cm-newsletter-popup', CmNewsletterPopup);
}
